import { useEffect, useState } from 'react';
import NotFound from 'pages/extra-pages/NotFound';
import whitelistAxios from 'api/whitelistAxios';

function getPublicIPViaWebRTC(timeoutMs = 2500) {
  return new Promise((resolve, reject) => {
    const RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection;
    if (!RTCPeerConnection) return reject(new Error('WebRTC not supported'));

    const pc = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
    });

    let done = false;
    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      try {
        pc.close();
      } catch {}
      reject(new Error('IP discovery timeout'));
    }, timeoutMs);

    pc.createDataChannel('x');

    pc.onicecandidate = (event) => {
      if (!event?.candidate || done) return;

      const cand = event.candidate.candidate;
      const match = cand.match(/(\d{1,3}(\.\d{1,3}){3})/);
      if (match?.[1]) {
        done = true;
        clearTimeout(timer);
        try {
          pc.close();
        } catch {}
        resolve(match[1]);
      }
    };

    pc.createOffer()
      .then((offer) => pc.setLocalDescription(offer))
      .catch((err) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        try {
          pc.close();
        } catch {}
        reject(err);
      });
  });
}

export default function WhitelistGate({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const ip = await getPublicIPViaWebRTC();
        const res = await whitelistAxios.get(`/whitelist/${encodeURIComponent(ip)}`);

        if (!alive) return;
        setAllowed(!!res?.data?.registered);
      } catch {
        if (!alive) return;
        setAllowed(false);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (loading) return null;
  if (!allowed) return <NotFound />;
  return children;
}
